import { render, staticRenderFns } from "./copyPopup.vue?vue&type=template&id=46c3d083&scoped=true"
import script from "./copyPopup.vue?vue&type=script&lang=js"
export * from "./copyPopup.vue?vue&type=script&lang=js"
import style0 from "./copyPopup.vue?vue&type=style&index=0&id=46c3d083&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3d083",
  null
  
)

export default component.exports